import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { finalize, tap } from 'rxjs';
import { ClassAssignmentHttpService } from './class-assignment-http.service';
import { AssignmentStudentStore } from './assignment-student.store';

@Injectable({ providedIn: 'root' })
export class AssignmentStudentService {
  constructor(
    private readonly store: AssignmentStudentStore,
    private readonly http: ClassAssignmentHttpService,
    private readonly errorHandler: ErrorHandlerService,
  ) {}

  init(assignmentId: string) {
    this.store.setLoading(true);

    return this.http.fetchAssignmentStudents(assignmentId).pipe(
      this.errorHandler.setHttpErrorMetadata({ entity: 'assignment_student', action: 'fetch' }),
      tap((students) => this.store.set(students)),
      finalize(() => this.store.setLoading(false)),
    );
  }
}
